import React from 'react';
import { Outlet } from 'react-router';
import { Stack } from '../../design-system/stack/stack';
import Header from '../layout/header';

const AccountsPage: React.FC = () => {
  return (
    <Stack align="stretch" className="min-h-screen p-2.5">
      <Stack align="stretch" className="flex-1 overflow-clip rounded-lg bg-white">
        <div className="overflow-clip">
          <Header />
        </div>

        <Outlet />
      </Stack>
    </Stack>
  );
};

export default AccountsPage;
